var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 650",
    style: {
      enableBackground: "new 0 0 650 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 188.8,
    r: 158.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M347.6,508.5c0-74.7,58-135.9,131.4-141.1c-14.3-18.1-31-34.1-49.7-47.6c-35.9,38.1-86.8,61.9-143.3,61.9 c-56.5,0-107.4-23.8-143.3-61.9C80.8,364.4,40.5,437.1,40.5,519.2c0,12.1,0.9,24,2.6,35.6c71.5,41.3,154.5,64.9,243,64.9 c35.4,0,70-3.8,103.3-11C363.5,583.2,347.6,547.7,347.6,508.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M584.8,528.7L584.8,528.7l29.3-6.2l0.5-22.2l-29-7.5c-1.4-8.4-3.8-16.6-7.3-24.3l0,0l20.1-22.2l-12.6-18.2l-27.9,11 c-5.9-5.9-12.7-11.1-20.2-15.4l3.2-29.8l-20.9-7.3L504,411.8c-8.5-1.3-17.1-1.5-25.4-0.6l-14.9-26l-21.2,6.4l1.8,29.9l0,0 c-7.5,3.9-14.6,8.7-20.9,14.4L396,423.7l-13.4,17.6l19.1,23.1l0,0c-1.9,3.7-3.5,7.6-5,11.7c-1.4,4.1-2.6,8.2-3.4,12.3l0,0l-29.3,6.2 l-0.5,22.2l29,7.5c1.4,8.4,3.8,16.6,7.3,24.3l0,0l-20.1,22.2l12.6,18.2l27.9-11c5.9,5.9,12.7,11.1,20.2,15.4l0,0l-3.2,29.8l20.9,7.3 l16.1-25.3l0,0c8.5,1.3,17.1,1.5,25.4,0.6l14.9,26l21.2-6.4l-1.8-29.9l0,0c7.5-3.9,14.6-8.7,20.9-14.4l27.3,12.2l13.4-17.6 l-19.1-23.1l0,0c1.9-3.7,3.6-7.7,5-11.7C582.8,536.9,583.9,532.8,584.8,528.7z M543.1,527.5c-10.5,29.8-43.2,45.5-73,35.1 c-29.8-10.5-45.5-43.2-35.1-73c10.5-29.8,43.2-45.5,73-35.1C537.8,465,553.5,497.7,543.1,527.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.80cbdce3.svg";
export { ForwardRef as ReactComponent };